// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__VBkvS","title":"styles_title__6FR8e","btn":"styles_btn__Q+T4f"};